import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPatientTherapySequenceActivities(
  sequenceId: string | undefined,
  medicineIds: string[] = []
) {
  return useQuery(
    queries.patientsTherapies.getSequenceActivitiesById({
      sequenceId: sequenceId || '',
      medicineIds,
    })
  )
}
